import * as $ from 'jquery';

class KentioForm {
  
  private kenticoForm = null;
  private countryDropdown = null;
  private stateDropdown = null;
  private stateInput = null;
  private newZealandStates = ['Auckland', 'Bay Of Plenty', 'Canterbury - West Coast', 'Gisborne - Hawkes bay', 'Nelson - Marlborough - Tasman', 'Northland', 'Otago - Southland', 'Taranaki - Wanganui - Manuwatu', 'Waikato', 'Wellington - Wairarapa'];
  private australiaSattes = ['New South Wales', 'Northern Territory', 'Queensland', 'South Australia', 'Tasmania', 'Victoria', 'Western Australia'];

  constructor() {
    
  }
  
  init = () => {
    let formElements = document.querySelectorAll('form');

    Array.prototype.map.call(formElements, (element) => {
      if(element.querySelector('.ktc-default-section') !== null) {
        let formlabelElements = element.querySelector('.ktc-default-section').querySelectorAll('.control-label');
        $(formlabelElements).each((index,label) => {
          if($(label).text().indexOf('Country') !== -1) {
            this.countryDropdown = $(label).next();
            // Make sure country filed is above state
          } else if ($(label).text().indexOf('State') !== -1 && this.countryDropdown) {            
            this.stateInput = $(label).next();
            $(label).next().after( "<select class='form-control stateDropdown hide'></select>" );
            this.stateDropdown = $('.stateDropdown');
          }
        })
      }
    });

    this.bindListeners();
  };

  bindListeners() {
    let _this = this;
    if(this.countryDropdown) {
      $(this.countryDropdown).on('change',function() {
        // handle country dropdown change.
        let selectedOptionText = $(this).find("option:selected").text();
        if(selectedOptionText === 'New Zealand' || selectedOptionText ===  'Australia') {
          _this.handleStateDropdownVisibility(selectedOptionText);
        }
        else {
          $(_this.stateInput).val('').removeClass('hide');  
          $(_this.stateDropdown).addClass('hide');
        }
       })
    }
    if(this.stateDropdown) {
      $(this.stateDropdown).on('change',function() {
        $(_this.stateInput).val($(this).val());
       })
    }
  }

  private handleStateDropdownVisibility(selectedText) {

    $(this.stateInput).addClass('hide');
    $(this.stateDropdown).empty().removeClass('hide');

    if(selectedText === 'New Zealand') {
      this.newZealandStates.forEach((state, index) => {
        this.handleSelectOptionAppend(state, index);
      })
    } else if (selectedText ===  'Australia') {
      this.australiaSattes.forEach((state, index) => {
        this.handleSelectOptionAppend(state, index);
      })
    }

  }

  private handleSelectOptionAppend(state, index) {
    if(index === 0) {
      $(this.stateInput).val(state);
    }
    $(this.stateDropdown).append($("<option></option>").attr("value", state).text(state));
  }

}

const KentioFormInstance = new KentioForm();
KentioFormInstance.init();

export { KentioForm, KentioFormInstance };

